import { Report193 } from "../../../components/borrowSystem/Report/Report193";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report193Container() {
  const titleName = "  สรุปข้อมูลการชำระหนี้และหนี้ค้างชำระ"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report193 />
      <Footer />
    </div>
  );
}
